import { Box, type BoxProps } from '@chakra-ui/react'

const defaultConfig: BoxProps = {
  p: 4,
  h: 'full',
  overflowY: 'auto',
  display: 'flex',
  flexDirection: 'column',
}

/**
 * Scrollable content shell for Help pages.
 * AdminLayout is already applied by generateRoutes — do not wrap AdminLayout here.
 */
export default function HelpPageLayout({
  children,
  mainBoxProps = defaultConfig,
}: {
  children: React.ReactNode
  mainBoxProps?: BoxProps
}) {
  return <Box {...mainBoxProps}>{children}</Box>
}
